export enum TokenAction {
  Zap = 'zap',
  BuySFI = 'buy-sfi',
  Stake = 'stake',
  Migrate = 'migrate',
  None = 'none',
}

export enum TokenRecordType {
  LockedToken = 'locked',
  IdleToken = 'idle',
}

export type TokenGroup = 'stable' | 'bluechip' | 'altcoin' | 'gold';

export interface BaseTokenRow {
  id: string;
  tokenAction: TokenAction;
  chainId: number;
  symbol: string;
  name: string;
  decimals: number;
  balance: bigint;
  balanceUsd: number;
  tokenGroup: TokenGroup;
  recordType: TokenRecordType;
  riskLevel: 'LOW' | 'MEDIUM' | 'HIGH' | 'NONE' | 'VERY_LOW';
}

export interface Position extends BaseTokenRow {
  tokenAction: TokenAction.None;
}

export interface VaultTokenRow extends BaseTokenRow {
  tokenAction: TokenAction.Zap;
  address: `0x${string}`;
  isDeposit: boolean;
  isStable: boolean;
}

export interface NativeTokenRow extends BaseTokenRow {
  tokenAction: TokenAction.BuySFI;
  buySFITokenHref: string;
}

export interface StakingTokenRow extends BaseTokenRow {
  tokenAction: TokenAction.Stake;
  address: `0x${string}`;
}

export interface MigrationTokenRow extends BaseTokenRow {
  tokenAction: TokenAction.Migrate;
  address: `0x${string}`;
  chainId: number;
}

export type TokenTableRow =
  | Position
  | VaultTokenRow
  | NativeTokenRow
  | StakingTokenRow
  | MigrationTokenRow;
